/**
 * Created by zad on 17/9/20.
 */
export default c => c.displayName || c.name || 'Component';



// WEBPACK FOOTER //
// ./src/utils/getComponentName.js